var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vote-container"},[_c('div',{staticClass:"vote-button noselect",on:{"click":() => {
        _vm.createVoteVisible = true;
      }}},[_c('h2',[_vm._v("Vote")])]),_c('vote-dialog',{attrs:{"visible":_vm.createVoteVisible,"roomId":_vm.roomId,"room":_vm.room,"userId":_vm.userId,"user":_vm.user},on:{"close":() => {
        _vm.createVoteVisible = false;
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }